/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Option_FailInputs */

const en_work_order_publish_option_fail = /** @type {(inputs: Work_Order_Publish_Option_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fail`)
};

const fr_work_order_publish_option_fail = /** @type {(inputs: Work_Order_Publish_Option_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec`)
};

const de_work_order_publish_option_fail = /** @type {(inputs: Work_Order_Publish_Option_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scheitern`)
};

const it_work_order_publish_option_fail = /** @type {(inputs: Work_Order_Publish_Option_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fallire`)
};

const ru_work_order_publish_option_fail = /** @type {(inputs: Work_Order_Publish_Option_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неудача`)
};

const es_work_order_publish_option_fail = /** @type {(inputs: Work_Order_Publish_Option_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fallar`)
};

const zh_cn2_work_order_publish_option_fail = /** @type {(inputs: Work_Order_Publish_Option_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`失败`)
};

const ja_work_order_publish_option_fail = /** @type {(inputs: Work_Order_Publish_Option_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`失敗`)
};

const hi_work_order_publish_option_fail = /** @type {(inputs: Work_Order_Publish_Option_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`असफल`)
};

const pt_pt2_work_order_publish_option_fail = /** @type {(inputs: Work_Order_Publish_Option_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falhar`)
};

/**
* | output |
* | --- |
* | "Fail" |
*
* @param {Work_Order_Publish_Option_FailInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_option_fail = /** @type {((inputs?: Work_Order_Publish_Option_FailInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Option_FailInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_work_order_publish_option_fail(inputs)
	if (locale === "de") return de_work_order_publish_option_fail(inputs)
	if (locale === "it") return it_work_order_publish_option_fail(inputs)
	if (locale === "ru") return ru_work_order_publish_option_fail(inputs)
	if (locale === "es") return es_work_order_publish_option_fail(inputs)
	if (locale === "zh-CN") return zh_cn2_work_order_publish_option_fail(inputs)
	if (locale === "ja") return ja_work_order_publish_option_fail(inputs)
	if (locale === "hi") return hi_work_order_publish_option_fail(inputs)
	if (locale === "pt-PT") return pt_pt2_work_order_publish_option_fail(inputs)
	return en_work_order_publish_option_fail(inputs)
});